import PictureListSing from '@/components/PictureList/PictureListSing'
import { WebCam } from 'vue-web-cam'
import DialogTable from '@/tycomponents/Dialog/DialogTable'
export default {
  components: {
    PictureListSing,WebCam,DialogTable
  },
  data() {
    function validatePhoneOrTel(rule,value,callback) {
      if (value === '' || value === null || value === undefined) {
        callback(); // 验证通过
        return;
      }
      let regex = /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/;

      if (value != null && !regex.test(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    }
    let checkMoney = (rule,value,callback) => {
       if (value === '' || value === null || value === undefined) {
        callback(); // 验证通过
        return;
      }
      var reg = /^-?(0|([1-9][0-9]*))(\.[\d]{1,2})?$/;
      if (!reg.test(value)) {
        callback(new Error("请输入数字,最多保留小数点2位！"));
      } else {
        callback();
      }
    };
    return {
      limitNum:1,
      picType:'img',
      optionsBooler:[
        {label:'是',value:true},{label:'否',value:false}
      ],
      optionsType:[
        {label:'未诉讼',value:0},{label:'已诉讼',value:1}
      ],
      url: {
        list: SZH.assets.api + '/Custom/GetPagingCases',
        GetCustomCaseInfoEntity: SZH.assets.api + '/Custom/GetCustomCaseInfoEntity',//获取案件详情
        SaveCaseCompanyInfo: SZH.assets.api + '/Custom/SaveCaseCompanyInfo',//保存企业信息
        SaveCaseInfo: SZH.assets.api + '/Custom/SaveCaseInfo',//保存案件信息
        DeleteCase: SZH.assets.api + '/Custom/DeleteCase',//删除案件
        SubmitCase: SZH.assets.api + '/Custom/SubmitCase',//提交案件
        PostFileWithBase64: SZH.assets.api + '/File/PostFileWithBase64',
        FaceCheck: SZH.assets.api + '/Custom/FaceCheck',//人脸检测
        GetCustomCaseFLWS: SZH.assets.api + '/Custom/GetCustomCaseFLWS',//人脸检测
        SaveFile: SZH.assets.api + '/Custom/SaveFile',//人脸检测
      },
      queryParams:{
        keyWord:'',
        startTime:'',
        endTime:''
      },
      value1: [],
      tableLoading:false,
      caseData: [],
      PageIndex:1,
      PageSize:50,
      total:0,
      comInfoVisible:false,
      loadingFull:false,
      form: {
        F_Id:'',
        F_CompanyName:'',//企业名称
        F_BusinessLicense:'',//社会统一信用代码
        F_Address:'',//联系地址
        F_JuridicalPersonName:'',//法人姓名
        F_JuridicalPersonIDNo:'',//法人身份证号
        F_JuridicalPersonTel:'',//法人手机号
        F_AccountBank:'',//开户银行
        F_Account:'',//开户银行账号
        F_IsAuthorize:false,//授权方式（true是 false否）
        F_YYZZImg_UrlBefore:[],//营业执照图片地址
        F_YYZZImg_Url:'',//营业执照图片地址
        F_FRSFZImg_UrlBefore:[],//法人身份证图片地址
        F_FRSFZImg_Url:'',//法人身份证图片地址
        F_YYKHXKImg_UrlBefore:[],//银行开户许可证图片地址
        F_YYKHXKImg_Url:'',//银行开户许可证图片地址
        F_AuthorizeImg_UrlBefore:[],//授权证明图片（授权方式为是时显示并必填）
        F_AuthorizeImg_Url:'',//授权证明图片（授权方式为是时显示并必填）
        F_AuthorizeName:'',//授权人姓名（授权方式为是时显示并必填）
        F_AuthorizeIDNo:'',//授权人身份证号（授权方式为是时显示并必填）
        F_AuthorizeSFZImg_UrlBefore:[],//授权人身份证图片（授权方式为是时显示并必填）
        F_AuthorizeSFZImg_Url:'',//授权人身份证图片（授权方式为是时显示并必填）
        F_AuthorizePhone:'',//授权人联系电话（授权方式为是时显示并必填）
        F_AuthorizeAddress:'',//授权人联系地址（授权方式为是时显示并必填）
        F_FaceImg_Url:'',//人脸识别图片
        F_AuditStatus:'',
        F_AuditMsg: null,
        F_AuditStatus2:'',
        F_AuditMsg2: null,
        F_ProjectName: null,
        F_DebtName: null,
      },
      rules: {
        F_CompanyName: [
          {required: true,message: "请输入企业名称",trigger: "blur"},
          {max: 20,message: "长度不能超过 20 个字符",trigger: "blur"},
        ],
        F_BusinessLicense: [
          {required: false,message: "请输入社会统一信用代码",trigger: "blur"},
        ],
        F_ProjectName: [
          {required: true,message: "请输入项目名称",trigger: "blur"},
        ],
        F_DebtName: [
          {required: false,message: "请输入债务单位名称",trigger: "blur"},
        ],
        F_Address: [
          {required: false,message: "请输入联系地址",trigger: "blur"},
        ],
        F_FaceImg_Url: [
          {required: true,message: "请人脸识别",trigger: "blur"},
        ],
        F_AuthorizeAddress: [
          {required: false,message: "请输入授权人联系地址",trigger: "blur"},
        ],
        F_JuridicalPersonName: [
          {required: false,message: "请输入法人姓名",trigger: "blur"},
        ],
        F_JuridicalPersonIDNo: [
          {required: false,message: "请输入法人身份证号",trigger: "blur"},
          // {
          //   validator: validateBusinessLicense,
          //   trigger: 'blur'
          // }
        ],
        F_JuridicalPersonTel: [
          {required: false,message: "请输入法人手机号",trigger: "blur"},
          {
            validator: validatePhoneOrTel,
            trigger: "blur",
          },
        ],
        F_AccountBank: [
          {required: false,message: "请输入开户银行",trigger: "blur"},
        ],
        F_Account: [
          {required: false,message: "请输入开户银行账号",trigger: "blur"},
        ],
        F_IsAuthorize: [
          {
            required: true,
            message: "请选择授权方式",
            trigger: "change",
          }
        ],
        F_YYZZImg_UrlBefore: [
          {required: false,message: "请选择营业执照图片",trigger: "blur"},
        ],
        F_FRSFZImg_UrlBefore: [
          {
            required:false,
            message:"请上传法人身份证!",
            trigger:"blur"
          }
        ],
        F_YYKHXKImg_UrlBefore: [
          {
            required:false,
            message:"请上传银行开户许可证!",
            trigger:"blur"
          }
        ],

        F_AuthorizeImg_UrlBefore: [
          {
            required: false,
            message: "请上传授权证明图片",
            trigger: "blur",
          },
        ],
        F_AuthorizeSFZImg_UrlBefore: [
          {
            required: false,
            message: "请上传授权人身份证图片",
            trigger: "blur",
          },
        ],
        F_AuthorizeName: [
          {
            required: false,
            message: "请输入授权人姓名",
            trigger: "blur",
          },
        ],
        F_AuthorizeIDNo: [
          {
            required: false,
            message: "请输入授权人身份证号",
            trigger: "blur",
          },
        ],
        F_AuthorizePhone: [
          {
            required: false,
            message: "请输入授权人电话",
            trigger: "blur",
          },
          {
            validator: validatePhoneOrTel,
            trigger: "blur",
          },
        ]
      },
      //案件相关
      caseInfoVisible:false,
      caseForm:{
        F_Id:'',//案件F_Id
        F_ProjectName:'',//项目名称
        F_OwnerName:'',//业主单位
        F_DebtName:'',//债务单位
        F_ClaimName:'',// 债权单位
        F_DebtMoney:'',// 债务总金额
        F_DebtMoneyOutstanding:'',// 未结清债务金额
        F_UnpaidReason:'',// 未付款原因
        F_ProjectProcess:'',// 项目过程阐述（从中标，开竣工时间，施工，验收，结算，付款，催款等情况请列明）
        F_Type:'',// 类型(0非诉案件、1诉讼案件、2执行案件)
      },
      rulesCase:{
        F_ProjectName: [
          {required: false,message: "请输入项目名称",trigger: "blur"},
        ],
        F_OwnerName: [
          {required: false,message: "请输入主单位",trigger: "blur"},
        ],
        F_DebtName: [
          {required: false,message: "请输入债务单位",trigger: "blur"},
        ],
        F_ClaimName: [
          {required: false,message: "请输入债权单位",trigger: "blur"},
        ],
        F_DebtMoney: [
          {required: false,message: "请输入债务总金额",trigger: "blur"},
          {
            validator: checkMoney,
            trigger: "change",
          },
        ],
        F_DebtMoneyOutstanding: [
          {required: false,message: "请输入未结清债务金额",trigger: "blur"},
          {
            validator: checkMoney,
            trigger: "change",
          },
        ],
        F_UnpaidReason: [
          {required: false,message: "请输入未付款原因",trigger: "blur"},
        ],
        F_ProjectProcess: [
          {required: false,message: "请输入项目过程阐述",trigger: "blur"},
        ],
        F_Type: [
          {required: false,message: "请选择类型",trigger: "change"},
        ],
      },
      caseInfos:[],//条木
      //案件相关End
    //  附件相关
      visibleFJ:false,
      queryParams3:{
        keyValue:''
      },
      url3:{
        list: SZH.assets.api + '/Custom/GetCaseAttachs',
        delete: SZH.assets.api + '/Custom/DeleteCaseAttach',
        save: SZH.assets.api + '/Custom/SaveCaseAttach',
        SelectItems: SZH.assets.api + '/Custom/SelectItems',
      },
      dialogFJVisible:false,
      fjForm:{
        F_Id:'',
        F_CaseId:'',//案件ID
        F_Type:'',
        F_Path:''
      },
      count:0,
      limit:1,
      hideUpload: false,
      fileList:[],
      optionsFJType:[],
      //附件ENd
      F_Id:'',
      fullscreenLoading:false,
      caseInfoAllVisible:false,
      caseFormAll:{},
      attachData:[],

      dialogFormVisible:false,
      imgFace:'',
      imgFaceLast:'',
      deviceId: null,
      devices: [],
      isCameraActive: true,
      currentDeviceIndex: 0,
      errorMessage: '',
      faceForm:{
        ID_ImageUrl:'',
        Face_ImageUrl:'',
        AgentName:''
      },
      lawForm:{
        F_FilePath:'',
        F_Id:''
      },
      limitLaw:1,
      fileListLaw:[],
      countLaw:0,
      dialogFJVisibleLaw:false,
      lawData:{
        F_FileName:'',
        F_FilePath:'',
        F_IsAllowCustomLoad:null
      },
      caseId:'',
      isEdit:false,
      dialogVisibleImg:false,
      dialogImageUrl:'',
      SubmitFlag:true,
      fjLoading:false
    }
  },
  methods: {
    //人脸
    faceFun(){
      let self = this;
      if(self.form.F_FRSFZImg_UrlBefore && self.form.F_FRSFZImg_UrlBefore.length == 0){
        self.$message.error('请先上传法人身份证照片!');
        return
      }
      self.dialogFormVisible = true;
      self.imgFace = '';
      self.$refs.webcam.start()
    },
    takePhoto() {
      try {
        this.imgFace = this.$refs.webcam.capture();
        this.errorMessage = ''
      } catch (error) {
        this.errorMessage = '拍照失败: ' + error.message
      }
    },

    switchCamera() {
      if (this.devices.length > 1) {
        this.currentDeviceIndex = (this.currentDeviceIndex + 1) % this.devices.length
        this.deviceId = this.devices[this.currentDeviceIndex].deviceId
      }
    },
    closeC(){
      this.dialogFormVisible = false;
      if (this.isCameraActive) {
        this.$refs.webcam.stop()
      }
    },
    toggleCamera() {
      if (this.isCameraActive) {
        this.$refs.webcam.stop()
      } else {
        this.$refs.webcam.start()
      }
      this.isCameraActive = !this.isCameraActive
    },

    retake() {
      this.imgFace = null
    },

    downloadPhoto() {
      if (!this.imgFace) return

      const link = document.createElement('a')
      link.href = this.imgFace
      link.download = `photo_${new Date().getTime()}.jpg`
      link.click()
    },

    uploadPhoto() {
      let self = this;
      if (!self.imgFace) return;
      // PostFileWithBase64
      self.loadingFull = true;
      self.$http.post(self.url.PostFileWithBase64,{
        base64Img:self.imgFace.split('base64,')[1],
        upLoadFolder:'人脸',
        ImageType:'faceImg',
      })
        .then(result => {
          if (result.state == true) {
            self.faceForm.Face_ImageUrl = result.data;
            self.checkFaceFun();
            self.loadingFull = false;
          } else {
            self.loadingFull = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('失败，请检查您的网络是否可用。');
        });
    },
    checkFaceFun(){
      let self = this;
      self.loadingFull = true;
      self.faceForm.ID_ImageUrl = self.form.F_FRSFZImg_UrlBefore[0].Url;
      self.faceForm.AgentName = self.form.F_CompanyName;
      self.$http.post(self.url.FaceCheck,self.faceForm)
        .then(result => {
          if (result.state == true) {
            self.form.F_FaceImg_Url = self.faceForm.Face_ImageUrl;
            self.imgFaceLast = self.imgFace;
            self.$message.success('人脸识别成功!');
            self.closeC();
            self.loadingFull = false;
          } else {
            self.loadingFull = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('失败，请检查您的网络是否可用。');
        });
    },
    onCameras(cameras) {
      this.devices = cameras;
      if (cameras.length > 0 && !this.deviceId) {
        this.deviceId = cameras[0].deviceId
      }
    },

    onError(error) {
      console.error('摄像头错误:', error)
      this.errorMessage = `摄像头错误: ${error.message}`

      // 提供用户友好的错误提示
      if (error.name === 'NotAllowedError') {
        this.errorMessage = '请允许摄像头访问权限'
      } else if (error.name === 'NotFoundError') {
        this.errorMessage = '未找到摄像头设备'
      } else if (error.name === 'NotReadableError') {
        this.errorMessage = '摄像头被占用或无法访问'
      }
    },

    // 工具方法：Base64转Blob
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1])
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab)

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ab], { type: mimeString })
    },
    //end
    changedFun(){
      this.form.F_FaceImg_Url = '';
      this.imgFace = '';
    },

    toDesc(row){
      this.$alert(row.F_AuditSuccessMsg, '提示', {
        confirmButtonText: '确定',
        center:true,
        callback: action => {
        }
      });
    },
    showImg(url){
      let self = this;
      if(!url){
        return
      }
      self.dialogVisibleImg = true;
      self.dialogImageUrl = SZH.assets.image +'/' + url;
    },
    toLaw(id){
      let self = this;
      self.$router.push({
        path:'/My/LawList',
        query:{
          id
        }
      })
      // self.dialogFJVisibleLaw = true;
      // self.fullscreenLoading = true;
      // self.caseId = id;
      // self.$http.post(self.url.GetCustomCaseFLWS,{
      //   keyValue:id
      // })
      //   .then(result => {
      //     if (result.state == true) {
      //       self.lawForm.F_Id = result.data.F_Id;
      //       self.lawData.F_FileName = result.data.F_FileName;
      //       self.lawData.F_FilePath = SZH.assets.image+'/' + result.data.F_FilePath;
      //       self.lawData.F_IsAllowCustomLoad = result.data.F_IsAllowCustomLoad;
      //       self.fullscreenLoading = false;
      //     } else {
      //       self.lawForm.F_Id = '';
      //       self.lawData.F_FileName = '';
      //       self.lawData.F_FilePath = '';
      //       self.lawData.F_IsAllowCustomLoad = null;
      //       self.fullscreenLoading = false;
      //       self.$message.error(result.message);
      //     }
      //   }, () => {
      //     self.fullscreenLoading = false;
      //     // 请求失败
      //     self.$message.error('失败，请检查您的网络是否可用。');
      //   });
    },
    saveLaw(){
      let self = this;
      if(!self.lawForm.F_FilePath){
        self.$message.error('请上传法律文书!');
        return
      }
      self.fullscreenLoading = true;
      self.$http.post(self.url.SaveFile,self.lawForm)
        .then(result => {
          if (result.state == true) {
            self.toLaw(self.caseId);
            self.dialogFJVisibleLaw = false;
            self.fullscreenLoading = false;
          } else {
            self.fullscreenLoading = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.fullscreenLoading = false;
          // 请求失败
          self.$message.error('失败，请检查您的网络是否可用。');
        });
    },
    toMessage(row){
      this.$router.push({
        path: '/My/MessageBoard',
        query:{
          caseId:row.F_Id,
          accountId:row.F_AccountId
        }
      })
    },
    getImgUrl(url){
      if(url){
        return SZH.assets.image +'/' + url
      }else{
        return ''
      }
    },
    onDelete(row){
      let self = this;
      self.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center:true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.DeleteCase,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.$message({
                type: 'success',
                message: '删除成功!'
              });
              self.searchBy();
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onDisplay(row){
      let self = this;
      self.caseInfoAllVisible = true;
      self.loadingFull = true;
      self.$http.post(self.url.GetCustomCaseInfoEntity,{
        keyValue:row.F_Id
      })
        .then(result => {
          if (result.state == true) {
            self.caseFormAll = result.data.caseData;
            self.caseInfos = result.data.caseInfos;
            self.attachData = result.data.caseAttachs;
          } else {
            self.caseFormAll = {};
            self.caseInfos = [];
            self.self.attachData = [];
            self.$message.error(result.message);
          }
          self.loadingFull = false;
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    onEdit(row){
      let self = this;
      self.isEdit = true;
      self.comInfoVisible = true;
      self.loadingFull = true;
      self.$http.post(self.url.GetCustomCaseInfoEntity,{
        keyValue:row.F_Id
      })
        .then(result => {
          if (result.state == true) {
            for(let i in self.form){
              self.form[i] = result.data.caseData[i];
              if(i == 'F_YYZZImg_Url'){
                self.form.F_YYZZImg_UrlBefore = result.data.caseData[i]?[{Url:result.data.caseData[i]}]:[]
              }
              if(i == 'F_FRSFZImg_Url'){
                self.form.F_FRSFZImg_UrlBefore = result.data.caseData[i]?[{Url:result.data.caseData[i]}]:[]
              }
              if(i == 'F_YYKHXKImg_Url'){
                self.form.F_YYKHXKImg_UrlBefore = result.data.caseData[i]?[{Url:result.data.caseData[i]}]:[]
              }
              // if(i == 'F_AuthorizeSFZImg_Url' && result.data.caseData[i]){
              //   self.form.F_AuthorizeSFZImg_UrlBefore = [{Url:result.data.caseData[i]}]
              // }
              // if(i == 'F_AuthorizeImg_Url' && result.data.caseData[i]){
              //   self.form.F_AuthorizeImg_UrlBefore = [{Url:result.data.caseData[i]}]
              // }
            }
            for(let i in self.caseForm){
              self.caseForm[i] = result.data.caseData[i]
            }
            self.caseInfos = result.data.caseInfos
          } else {
            self.$message.error(result.message);
          }
          self.loadingFull = false;
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    addFun(){
      let self = this;
      self.isEdit = false;
      self.caseInfos = [];
      self.comInfoVisible = true
    },
    handleDialogOpen(){
      this.$nextTick(()=>{
        this.$refs['formYY'].resetFields();
      });
    },
    handleDialogOpenCase(){
      // this.$nextTick(()=>{
      //   this.$refs['formCase'].resetFields();
      // });
    },
    saveCom(){
      let self = this;
      self.$refs['formYY'].validate((valid) => {
        if (valid) {
          self.form.F_YYZZImg_Url = (self.form.F_YYZZImg_UrlBefore && self.form.F_YYZZImg_UrlBefore.length>0)?self.form.F_YYZZImg_UrlBefore[0].Url:'';
          self.form.F_FRSFZImg_Url = (self.form.F_FRSFZImg_UrlBefore && self.form.F_FRSFZImg_UrlBefore.length>0)?self.form.F_FRSFZImg_UrlBefore[0].Url:'';
          self.form.F_YYKHXKImg_Url = (self.form.F_YYKHXKImg_UrlBefore && self.form.F_YYKHXKImg_UrlBefore.length>0)?self.form.F_YYKHXKImg_UrlBefore[0].Url:'';
          // self.form.F_AuthorizeImg_Url = (self.form.F_AuthorizeImg_UrlBefore && self.form.F_AuthorizeImg_UrlBefore.length>0)?self.form.F_AuthorizeImg_UrlBefore[0].Url:'';
          // self.form.F_AuthorizeSFZImg_Url = (self.form.F_AuthorizeSFZImg_UrlBefore && self.form.F_AuthorizeSFZImg_UrlBefore.length>0)?self.form.F_AuthorizeSFZImg_UrlBefore[0].Url:'';
          self.loadingFull = true;
          self.$http.post(self.url.SaveCaseCompanyInfo,self.form)
            .then(result => {
              if (result.state == true) {
                self.$message.success('保存成功');
                self.F_Id = result.data;
                self.comInfoVisible = false;
                self.caseInfoVisible = true;
                self.caseForm.F_ProjectName = self.form.F_ProjectName;
                self.caseForm.F_DebtName = self.form.F_DebtName;
                self.caseForm.F_ClaimName = self.form.F_CompanyName;
                self.searchBy();
              } else {
                self.F_Id = '';
                self.$message.error(result.message);
              }
              self.loadingFull = false;
            }, () => {
              self.loadingFull = false;
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addItem(){
      let self = this;
      let obj = {
        F_ProjectName:'',
        F_ProjectMoney:'',
        F_IsComplate:'',
        F_IsGvmAccounting:'',
        F_IsAttachment:'',
        // F_IsLitigation:null,
      };
      self.caseInfos.push(obj)
    },
    deleteItem(index){
      this.caseInfos.splice(index,1);
    },
    allPropertiesHaveValue(arr) {//验证数组中是否有值
      return arr.every(obj => {
        return Object.values(obj).every(value => {
          return value !== undefined &&
            // value !== null &&
            value !== '';
        });
      });
    },
    saveCase(){
      let self = this;
      // if(self.caseInfos && self.caseInfos.length == 0){
      //   self.$message.error('请添加项目工程进度!');
      //   return
      // }
      // let hasCase = self.allPropertiesHaveValue(self.caseInfos);
      // if(!hasCase){
      //   self.$message.error('项目工程进度填写有遗漏信息，请仔细填写!');
      //   return
      // }
      self.caseForm.F_Id = self.F_Id;
      self.$refs['formCase'].validate((valid) => {
        if (valid) {
          self.loadingFull = true;
          self.$http.post(self.url.SaveCaseInfo,{
            caseData:self.caseForm,
            caseInfos:self.caseInfos
          })
            .then(result => {
              if (result.state == true) {
                self.$message.success('保存成功');
                self.SubmitFlag = true;
                self.queryParams3.keyValue = self.F_Id;
                self.caseInfoVisible = false;
                self.visibleFJ = true;
                self.searchBy();
              } else {
                self.$message.error(result.message);
              }
              self.loadingFull = false;
            }, () => {
              self.loadingFull = false;
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toImprove(row){
      let self = this;
      self.SubmitFlag = false;
      self.queryParams3.keyValue = row.F_Id;
      self.visibleFJ = true;
      self.F_Id = row.F_Id;
    },
    prViewFJ(row){
      window.open(SZH.assets.image +'/' + row.F_Path);
    },
    saveLast(){
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.SubmitCase,{
        keyValue:self.F_Id
      }).then(result => {
        if (result.state == true) {
          self.$message.success('提交成功!');
          self.visibleFJ = false;
          self.searchBy();
        } else {
          self.$message.error(result.message);
        }
        self.fullscreenLoading = false;
      }, () => {
        self.fullscreenLoading = false;
      });
    },
    onSizeChange(val) {
      this.PageSize = val;
      this.loadData();
    },
    onCurrentChange(val) {
      this.PageIndex = val;
      this.loadData();
    },
    changeTime(val){
      if(val && val.length>0){
        this.queryParams.startTime = val[0];
        this.queryParams.endTime = val[1];
      }
    },
    searchBy(){
      let self = this;
      self.PageIndex = 1;
      self.loadData();
    },
    loadData(){
      let self = this;
      self.tableLoading = true;
      self.$http.post(self.url.list,{
        Data:self.queryParams,
        PageIndex:self.PageIndex,
        PageSize:self.PageSize
      })
        .then(result => {
          if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
            self.caseData = result.data.Data;
            self.total = result.data.TotalCount;
            self.tableLoading = false;
          } else {
            self.caseData = [];
            self.total = 0;
            self.tableLoading = false;
            self.$message.error(result.message?result.message:'暂无数据');
          }
        }, () => {
          self.tableLoading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    getItems(){
      let self = this;
      self.$http.post(self.url3.SelectItems, {
        keyValue:'CaseAttach'
      }).then(result => {
        if (result.state == true) {
          self.optionsFJType = result.data
        } else {
          self.optionsFJType = [];
        }
      }, () => {
      });
    },
    addFJ(){
      let self = this;
      self.fjForm.F_Type = '';
      self.fileList = [];
      self.fjForm.F_Path = '';
      self.dialogFJVisible = true;
    },
    async saveManyFJ(){
      let self = this;
      const loading = self.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      if(!self.fjForm.F_Type){
        self.$message.error('请选择附件类型!');
        return
      }
      if(self.fileList && self.fileList.length == 0){
        self.$message.error('请选择附件!');
        return
      }
      try {
        for (const item of self.fileList) {
          await self.saveFJ(item.response)
        }
        console.log('所有 POST 请求已完成')
        self.dialogFJVisible = false;
        self.$refs['dialogFJ'].reload();
      } catch (error) {
        console.error('请求中断', error)
      } finally {
        loading.close()
      }
    },
    saveFJ(item){
      let self = this;
      self.fjForm.F_Path = item[0].FileName;
      self.fjForm.F_CaseId = self.F_Id;
      return self.$http.post(self.url3.save, self.fjForm).then(result => {
        if (result.state == true) {
          self.$message.success('上传成功!');
        } else {
          self.$message.error(result.message);
        }
      }, () => {
      });
    },
    deleteFJ(row){
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url3.delete, {
        keyValue:row.F_Id
      }).then(result => {
        if (result.state == true) {
          self.$message.success('删除成功!');
          self.dialogFJVisible = false;
          self.$refs['dialogFJ'].reload();
        } else {
          self.$message.error(result.message);
        }
        self.fullscreenLoading = false;
      }, () => {
        self.fullscreenLoading = false;
      });
    },
    beforeUpload(file){
      const self = this;
      // if(self.fileList && self.fileList.length>0){
      //   self.$message.error('文件只能上传一次！');
      //   return
      // }
      const isPDF = file.type === 'application/pdf';
      const isLt2M = file.size / 1024 / 1024 < 100;
      // if (!isPDF) {
      //   _self.$message.error('上传的文件只能是PDF格式!');
      // }else if (!isLt2M) {
      //   _self.$message.error('上传的文件大小不能超过 30MB!');
      // }
      if (!isLt2M) {
        self.$message.error('上传的文件大小不能超过 100MB!');
      }
      return isLt2M;
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
      if (response && response[0].success == true) {
        // this.count = fileList.length;
        // this.fileList = [];
        // this.fjForm.F_Path = response[0].FileName;
        // let obj = {
        //   name:'',
        //   url:''
        // };
        // obj.name = response[0].File;
        // obj.url = response[0].FileName;
        // this.fileList.push(obj);
      }else{
        this.$message.error(response[0].message)
      }
    },
    handleRemove(file, fileList) {
      var self = this;
      self.count = fileList.length;
      self.fjForm.F_Path = '';
      self.fileList = [];
    },

    beforeUploadLaw(file){
      const self = this;
      if(self.fileListLaw && self.fileListLaw.length>0){
        self.$message.error('文件只能上传一次！');
        return
      }
      const isPDF = file.type === 'application/pdf';
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isPDF) {
        self.$message.error('上传的文件只能是PDF格式!');
      }else if (!isLt2M) {
        self.$message.error('上传的文件大小不能超过 100MB!');
      }

      return isLt2M && isPDF;
    },
    handleSuccessLaw(response, file, fileList) {
      if (response && response[0].success == true) {
        this.countLaw = fileList.length;
        this.fileListLaw = [];
        this.lawForm.F_FilePath = response[0].FileName;
        let obj = {
          name:'',
          url:''
        };
        obj.name = response[0].File;
        obj.url = response[0].FileName;
        this.fileListLaw.push(obj);
      }else{
        this.$message.error(response[0].message)
      }
    },
    handleRemoveLaw(file, fileList) {
      var self = this;
      self.countLaw = fileList.length;
      self.lawForm.F_FilePath = '';
      self.fileListLaw = [];
    },
  },
  computed: {
    uploadHeaders() {
      var token = localStorage.ms_token;
      return {Authorization: 'Bearer ' + token};
    },
    uploadUrl() {
      return SZH.assets.api + '/File/PostFile'
    },
    extraParams(){
      return {
        upLoadType:'2',
        upLoadFolder:'',
        ImageType:'fujian',
        code:''
      }
    },
    extraParamsLaw(){
      return {
        upLoadType:'2',
        upLoadFolder:'',
        ImageType:'CaseFLWS',
        code:''
      }
    }
  },

  mounted() {
    this.loadData();
    this.getItems();
  }
}



// WEBPACK FOOTER //
// ./src/views/Me/CaseManagement/CaseManagement.js